import moment from 'moment';
import * as types from '../../constants/actionsType'
import Edit from '../../../asset/svg/EditIcon.svg';
import Delete from '../../../asset/svg/Delete.svg'

const initialState = {
  applicationCategory: [],
  applicationCategoryDropDown: [],
  isLoadingApplicationCategory: true,
  application: [],
  isLoadingApplication: false,
  isUpdateApplication: false,
  exceptionApplication: [],
  isLoadingExceptionApplication: true,
  searchAddException: [],
  isLoadingSearchAddException: false,
  isUpdateAddExceptionApplication: false,
  isLoadingProductiveApp: false,
  applicationList: [],
  isLoadingApplicationList: false,
  count: 0
}
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SUCCESS_APPLICATION_CATEGORY:
      var data = action.data.map(i => {
        return [i.category, i.appCount, i.id, i.id]
      })
      var dropdown = []
      action.data.length > 0 && action.data.map(i => {
        dropdown.push({ name: i.category, value: i.id })
      })
      return {
        ...state,
        applicationCategory: {
          head: [
            { label: "Application Category", align: "left" },
            { label: "Count", align: "right", isChip: true },
            {
              label: "Action", align: "right", isButton: true, child: [
                { name: 'Delete', icon: Delete }
              ]
            },
          ],
          body: data
        },
        applicationCategoryDropDown: dropdown,
        isLoadingApplicationCategory: false
      }
    case types.FETCH_APPLICATION_CATEGORY:

      return {
        ...state,
        applicationCategory: {
          head: [],
          body: []
        },
        applicationCategoryDropDown: [],
        isLoadingApplicationCategory: true,
        application: [],
        isLoadingApplication: true
      }

    case types.DELETE_APPLICATION_CATEGORY:
      var data = state.applicationCategory.body.filter(i => i[2] != action.data)

      return {
        ...state,
        applicationCategory: {
          head: state.applicationCategory.head,
          body: data
        },
        isLoadingApplicationCategory: false
      }
    case types.FAILED_APPLICATION_CATEGORY:
      return {
        ...state,
        applicationCategory: [],
        isLoadingApplicationCategory: false,
        applicationCategoryDropDown: []
      }

    case types.SUCCESS_APPLICATION:
      return {
        ...state,
        application: action.data,
        isLoadingApplication: false
      }
    case types.UPDATE_APPLICATION:
      var app = state.application.filter(i => i != action.data)
      return {
        ...state,
        application: app,
        isLoadingApplication: false
      }
    case types.FAILED_APPLICATION_CATEGORY:
      return {
        ...state,
        application: [],
        isLoadingApplication: false
      }
    case types.UPDATE_PRODUCTIVE_APPLICATION:
      const fullData = state.application.map(i => {
        if (action.id == i.id) {
          return { ...i, isProductive: action.isProductive }
        } else {
          return { ...i }
        }
      })
      return {
        ...state,
        application: fullData,
        isUpdateApplication: true
      }
    case types.REMOVE_UPDATE_APPLICATION_FLAG:
      return {
        ...state,
        isUpdateApplication: false
      }
    case types.SUCCESS_EXCEPTION_APPLICATION:
      return {
        ...state,
        exceptionApplication: action.data,
        isLoadingExceptionApplication: false
      }
    case types.FAILED_EXCEPTION_APPLICATION:
      return {
        ...state,
        exceptionApplication: [],
        isLoadingExceptionApplication: false
      }
    case types.SUCCESS_SEARCH_ADD_EXCEPTION_APPLICATION:
      return {
        ...state,
        searchAddException: action.data.map(i => ({ id: i.id, applicationName: i.applicationName, category: i.category, appLogo: i.appLogo, isProductive: null, idleTimeApplicable: i.idleTimeApplicable, idleMaxSeconds: i.idleMaxSeconds })),
        isLoadingSearchAddException: false
      }
    case types.FAILED_SEARCH_ADD_EXCEPTION_APPLICATION:
      return {
        ...state,
        searchAddException: [],
        isLoadingSearchAddException: false
      }
    case types.UPDATE_ADD_EXCEPTION_APPLICATION:
      return {
        ...state,
        isUpdateAddExceptionApplication: true
      }
    case types.REMOVE_UPDATE_ADD_EXCEPTION_APPLICATION_FLAG:
      return {
        ...state,
        isUpdateAddExceptionApplication: false
      }
    case types.LOADING_PRODUCTIVE_APPLICATION:
      return {
        ...state,
        isLoadingProductiveApp: action.data
      }
    case types.SUCCESS_APPLICATION_LIST:
      //console.log(action.data)
      var count = 0
      var data = action.data.map(i => {
        count = i.totalCount;
        return [i.skipFlag ? { name: i.applicationName, skipFlags: i.skipFlag } : i.applicationName, i.applicationCategory, i.applicationType, i.displayName, { isProdButton: true, isProductive: i.isProductive, isProdLoading: false, isNonCoreLoading: false }, i]
      })
      return {
        ...state,
        applicationList: {
          head: [{
            label: 'Application Name',
            align: 'left'
          },
          {
            label: 'Application Category',
            align: 'left'
          },
          {
            label: 'Application Type',
            align: 'left'
          },
          {
            label: 'Display Name',
            align: 'left'
          },
          {
            label: "", align: "center",
          },
          {
            label: "Action", align: "right",
          },
          ],
          body: data
        },
        count: count,
        isLoadingApplicationList: false
      }
    case types.FAILED_APPLICATION_LIST:
      return {
        ...state,
        applicationList: {
          head: [],
          body: []
        },
        count: 0,
        isLoadingApplicationList: false
      }
    case types.LOADING_APPLICATION_LIST:
      return {
        ...state,
        applicationList: {
          head: [],
          body: []
        },
        count: 0,
        isLoadingApplicationList: true
      }
    case types.DELETE_APPLICATION_LIST: {
      var actualvalue = state.applicationList.body.map(value => {
        if (value[5].id == action.data.id) {
          value[0] = { name: value[0], skipFlags: true };
          value[5].skipFlag = true;
          return value;
        } else {
          return value;
        }
      })
      return {
        ...state,
        applicationList: {
          head: state.applicationList.head,
          body: actualvalue
        }
      }
    }
    case types.EDIT_APPLICATION_LIST: {
      var actualvalue = state.applicationList.body.map(value => {
        if (value[5].id == action.data.id) {
          value[3] = action.data.displayName;
          value[1] = action.data.application;
          value[5].displayName = action.data.displayName;
          value[5].applicationCategory = action.data.application;
          value[5].categoryID = action.data.applicationID;
          return value;
        } else {
          return value;
        }
      })

      return {
        ...state,
        applicationList: {
          head: state.applicationList.head,
          body: actualvalue
        }
      }
    }
    case types.FETCH_CHANGE_PRODUCTIVE: {
      var actualvalue = state.applicationList.body.map(value => {
        if (value[5].id == action.data) {
          if (action.isProductive) {
            value[4].isProdLoading = true

          } else {
            value[4].isNonCoreLoading = true
          }
          value[4].isProductive = !action.isProductive
          return value;
        } else {
          return value;
        }
      })
      return {
        ...state,
        applicationList: {
          head: state.applicationList.head,
          body: actualvalue
        }
      }
    }
    case types.SAVE_CHANGE_PRODUCTIVE: {
      var actualvalue = state.applicationList.body.map(value => {
        if (value[5].id == action.data) {

          value[4].isProdLoading = false;
          value[4].isNonCoreLoading = false;
          value[4].isProductive = action.isProductive
          return value;
        } else {
          return value;
        }
      })
      return {
        ...state,
        applicationList: {
          head: state.applicationList.head,
          body: actualvalue
        }
      }
    }
    default:
      return state
  }
}
export default reducer
